import DropdownLayout from "../../../components/DropdownLayout";
import type { RuleItemEditorBaseProps } from "../ruleItemEditorTypes";

type Props = RuleItemEditorBaseProps & {
  data: any;
  availableFields: { label: string; value: string; key?: string }[];
  isFilterRule?: boolean;
};

export default function RuleItemEditorFieldPicker({
  ruleItem,
  updateRuleItem,
  t,
  data,
  availableFields,
  isFilterRule = false,
}: Props) {
  const selectedValue = availableFields.find((item) => item.value === data.fieldId) || {
    label: "field",
  };
  const actionLabel = isFilterRule ? "has" : "in";

  return (
    <>
      <div className="px-2">{t(actionLabel)}</div>
      <div className="align-middle">
        <DropdownLayout
          activator={
            <div className="decoration-1 underline cursor-pointer text-blue-400 font-bold flex space-x-2 lowercase">
              <div>{selectedValue?.label}</div>
            </div>
          }
          fullWidth={false}
          positionClassName="left-0 origin-top-left"
        >
          <ul className="w-fit">
            {availableFields.map((item, index) => (
              <li
                className="px-3 py-2 hover:bg-blue-400 hover:text-white cursor-pointer"
                key={`field_${item.value}_${index}`}
                title={item.label}
                onClick={() => {
                  updateRuleItem({
                    ...ruleItem,
                    data: {
                      ...ruleItem.data,
                      fieldId: item.value,
                      to: { value: "" },
                    },
                  });
                }}
              >
                <div className="truncate ...">{item.label}</div>
              </li>
            ))}
          </ul>
        </DropdownLayout>
      </div>
    </>
  );
}
